module.exports = __webpack_public_path__ + "img/dark-green-circle-table-4.bfc8cdfd.png";